/**
 * Tətbiqin statik mətnləri — 3 dildə (az / en / ru).
 *
 * Bu fayl DEFAULT-dur. Backend-dəki `ui_texts` cədvəlində eyni açar varsa,
 * super admin panelindən yazılan dəyər bunun ÜSTÜNÜ ÖRTÜR (deploy tələb olunmur).
 * Bax: GET /api/v1/ui-texts və App\Models\UiText.
 *
 * {dəyişən} formalı yer tutucular t("key", { dəyişən: "..." }) ilə doldurulur.
 */
const dictionary = {
  /* ---------------- ümumi ---------------- */
  "common.loading": { az: "Yüklənir...", en: "Loading...", ru: "Загрузка..." },
  "common.back": { az: "← Geri", en: "← Back", ru: "← Назад" },
  "common.retry": { az: "Yenidən cəhd et", en: "Try again", ru: "Повторить" },
  "common.copy": { az: "📋 Kopyala", en: "📋 Copy", ru: "📋 Копировать" },
  "common.copied": { az: "Kod kopyalandı!", en: "Code copied!", ru: "Код скопирован!" },
  "common.days_left": { az: "{count} gün qalıb", en: "{count} days left", ru: "Осталось {count} дн." },
  "common.unlimited": { az: "limitsiz", en: "unlimited", ru: "без лимита" },

  /* ---------------- naviqasiya ---------------- */
  "nav.stores": { az: "Mağazalar", en: "Stores", ru: "Магазины" },
  "nav.coupons": { az: "🎟 Kuponlarım", en: "🎟 My coupons", ru: "🎟 Мои купоны" },
  "nav.subscription": { az: "Abunəliyim", en: "My subscription", ru: "Моя подписка" },
  "nav.plans": { az: "Paketlər", en: "Plans", ru: "Тарифы" },
  "nav.login": { az: "Daxil ol", en: "Log in", ru: "Войти" },
  "nav.logout": { az: "Çıxış", en: "Log out", ru: "Выйти" },

  /* ---------------- mağaza siyahısı ---------------- */
  "home.title": { az: "Oyna, Qazan! 🎉", en: "Play & Win! 🎉", ru: "Играй и выигрывай! 🎉" },
  "home.subtitle": {
    az: "Mağazanı seç, suallara cavab ver, real endirim kuponu qazan.",
    en: "Pick a store, answer the questions and win a real discount coupon.",
    ru: "Выберите магазин, ответьте на вопросы и получите реальный купон на скидку.",
  },
  "home.view_campaigns": { az: "Kampaniyalara bax →", en: "View campaigns →", ru: "Смотреть кампании →" },
  "home.empty_title": { az: "Hazırda aktiv mağaza yoxdur", en: "No active stores right now", ru: "Сейчас нет активных магазинов" },
  "home.empty_subtitle": { az: "Bir azdan yenidən yoxlayın.", en: "Please check back soon.", ru: "Загляните чуть позже." },

  /* ---------------- mağaza səhifəsi ---------------- */
  "store.not_found": { az: "Mağaza tapılmadı", en: "Store not found", ru: "Магазин не найден" },
  "store.back_to_stores": { az: "← Mağazalara qayıt", en: "← Back to stores", ru: "← К магазинам" },
  "store.active_campaigns": { az: "🎯 Aktiv kampaniyalar", en: "🎯 Active campaigns", ru: "🎯 Активные кампании" },
  "store.no_quiz": {
    az: "Bu mağazada hazırda aktiv kampaniya yoxdur.",
    en: "This store has no active campaign right now.",
    ru: "В этом магазине сейчас нет активных кампаний.",
  },
  "store.questions_count": { az: "📋 {count} sual", en: "📋 {count} questions", ru: "📋 {count} вопросов" },
  "store.per_question": { az: "⏱ {sec}s / sual", en: "⏱ {sec}s / question", ru: "⏱ {sec}с / вопрос" },
  "store.play_button": { az: "🚀 Oyna", en: "🚀 Play", ru: "🚀 Играть" },
  "store.reward_tiered": {
    az: "{count}+ düz cavab → {reward} qazan!",
    en: "{count}+ correct answers → win {reward}!",
    ru: "{count}+ правильных ответов → {reward}!",
  },
  "store.reward_flat": {
    az: "Keçid balını topla → {reward} qazan!",
    en: "Reach the pass score → win {reward}!",
    ru: "Наберите проходной балл → {reward}!",
  },
  "store.reward_default": {
    az: "Suallara cavab ver, endirim qazan!",
    en: "Answer the questions and win a discount!",
    ru: "Отвечайте на вопросы и получайте скидку!",
  },

  /* ---------------- quiz ---------------- */
  "play.ready_title": { az: "Quizə hazırsan?", en: "Ready for the quiz?", ru: "Готовы к квизу?" },
  "play.ready_desc": {
    az: "Hər suala vaxt limiti var — düşün, amma gecikmə! Düzgün cavablar sənə real endirim kuponu qazandırır. 💸",
    en: "Every question has a time limit — think fast! Correct answers earn you a real discount coupon. 💸",
    ru: "На каждый вопрос есть время — думайте быстро! Правильные ответы дают реальный купон на скидку. 💸",
  },
  "play.guest_note": {
    az: "ℹ️ Qeydiyyatsız oynaya bilərsən — kuponu almaq üçün sonda qeydiyyat lazım olacaq.",
    en: "ℹ️ You can play without an account — registration is required only to claim the coupon.",
    ru: "ℹ️ Можно играть без регистрации — она нужна только для получения купона.",
  },
  "play.start": { az: "🚀 Başla", en: "🚀 Start", ru: "🚀 Начать" },
  "play.loading_questions": { az: "Suallar hazırlanır...", en: "Preparing questions...", ru: "Готовим вопросы..." },
  "play.checking_answers": { az: "Cavablar yoxlanılır...", en: "Checking answers...", ru: "Проверяем ответы..." },
  "play.error_title": { az: "Nəsə səhv getdi", en: "Something went wrong", ru: "Что-то пошло не так" },
  "play.question_of": { az: "Sual {current} / {total}", en: "Question {current} / {total}", ru: "Вопрос {current} / {total}" },
  "play.congrats": { az: "Təbriklər!", en: "Congratulations!", ru: "Поздравляем!" },
  "play.failed": { az: "Bu dəfə alınmadı", en: "Not this time", ru: "В этот раз не вышло" },
  "play.result": { az: "Nəticə:", en: "Result:", ru: "Результат:" },
  "play.correct_answers": { az: "düzgün cavab", en: "correct answers", ru: "правильных ответов" },
  "play.your_coupon": { az: "Endirim kuponun", en: "Your discount coupon", ru: "Ваш купон на скидку" },
  "play.discount_won": { az: "{reward} endirim", en: "{reward} discount", ru: "скидка {reward}" },
  "play.expires": { az: "Son istifadə: {date}", en: "Valid until: {date}", ru: "Действует до: {date}" },
  "play.copy_code": { az: "📋 Kodu kopyala", en: "📋 Copy code", ru: "📋 Скопировать код" },
  "play.guest_won": { az: "🎁 {reward} endirim qazandın!", en: "🎁 You won a {reward} discount!", ru: "🎁 Вы выиграли скидку {reward}!" },
  "play.guest_register_desc": {
    az: "Kuponunu əldə etmək üçün qeydiyyatdan keç — nəticən yadda saxlanılıb.",
    en: "Register to claim your coupon — your result has been saved.",
    ru: "Зарегистрируйтесь, чтобы получить купон — результат сохранён.",
  },
  "play.register_cta": { az: "Qeydiyyatdan keç → Kuponu al", en: "Register → Claim coupon", ru: "Регистрация → Получить купон" },
  "play.have_account": { az: "Hesabım var — daxil ol", en: "I have an account — log in", ru: "У меня есть аккаунт — войти" },
  "play.not_passed": {
    az: "Keçid balını toplaya bilmədin. Bir də cəhd et! 💪",
    en: "You did not reach the pass score. Try again! 💪",
    ru: "Проходной балл не набран. Попробуйте ещё раз! 💪",
  },
  "play.play_again": { az: "🔄 Yenidən oyna", en: "🔄 Play again", ru: "🔄 Играть снова" },
  "play.back_to_store": { az: "🏪 Mağazaya qayıt", en: "🏪 Back to store", ru: "🏪 Вернуться в магазин" },
  "play.sub_required_title": { az: "Abunəlik lazımdır", en: "Subscription required", ru: "Нужна подписка" },
  "play.sub_required_default": {
    az: "Quiz oynamaq üçün aktiv abunəliyiniz olmalıdır.",
    en: "You need an active subscription to play the quiz.",
    ru: "Для игры нужна активная подписка.",
  },
  "play.sub_view_plans": { az: "Paketlərə bax →", en: "View plans →", ru: "Смотреть тарифы →" },
  "play.sub_claim_desc": {
    az: "Kuponu əldə etmək üçün aktiv abunəliyin olmalıdır. Abunə olduqdan sonra nəticən avtomatik kupona çevriləcək.",
    en: "You need an active subscription to claim the coupon. Once you subscribe, your result turns into a coupon automatically.",
    ru: "Для получения купона нужна активная подписка. После оформления результат автоматически станет купоном.",
  },
  "play.sub_claim_cta": { az: "💳 Abunə ol → Kuponu al", en: "💳 Subscribe → Claim coupon", ru: "💳 Оформить → Получить купон" },

  /* ---------------- kuponlar ---------------- */
  "coupons.title": { az: "🎟 Kuponlarım", en: "🎟 My coupons", ru: "🎟 Мои купоны" },
  "coupons.empty": { az: "Hələ kuponun yoxdur", en: "You have no coupons yet", ru: "У вас пока нет купонов" },
  "coupons.empty_desc": {
    az: "Mağazalardan birini seç, quiz oyna və endirim qazan!",
    en: "Pick a store, play a quiz and win a discount!",
    ru: "Выберите магазин, сыграйте в квиз и получите скидку!",
  },
  "coupons.browse": { az: "Mağazalara bax →", en: "Browse stores →", ru: "Смотреть магазины →" },
  "coupons.expires": { az: "Son istifadə: {date}", en: "Valid until: {date}", ru: "Действует до: {date}" },
  "coupons.status.active": { az: "Aktiv", en: "Active", ru: "Активен" },
  "coupons.status.redeemed": { az: "İstifadə olunub", en: "Redeemed", ru: "Использован" },
  "coupons.status.expired": { az: "Müddəti bitib", en: "Expired", ru: "Истёк" },
  "coupons.status.revoked": { az: "Ləğv edilib", en: "Revoked", ru: "Отменён" },
  "discount.percent": { az: "{value}% endirim", en: "{value}% discount", ru: "скидка {value}%" },
  "discount.amount": { az: "{value} AZN endirim", en: "{value} AZN discount", ru: "скидка {value} AZN" },

  /* ---------------- giriş / qeydiyyat ---------------- */
  "auth.login_title": { az: "Daxil ol", en: "Log in", ru: "Вход" },
  "auth.register_title": { az: "Qeydiyyat", en: "Sign up", ru: "Регистрация" },
  "auth.welcome_title": { az: "Xoş gəlmisən! 👋", en: "Welcome! 👋", ru: "Добро пожаловать! 👋" },
  "auth.welcome_desc": {
    az: "Quiz oyna, düzgün cavab ver və sevdiyin mağazalardan real endirim kuponları qazan.",
    en: "Play quizzes, answer correctly and win real discount coupons from your favourite stores.",
    ru: "Играйте в квизы, отвечайте правильно и получайте реальные купоны любимых магазинов.",
  },
  "auth.join_title": { az: "Aramıza qoşul! 🚀", en: "Join us! 🚀", ru: "Присоединяйтесь! 🚀" },
  "auth.join_desc": {
    az: "Qeydiyyatdan keç, quiz oyna və sevdiyin mağazalardan endirim kuponları qazan.",
    en: "Sign up, play quizzes and win discount coupons from your favourite stores.",
    ru: "Зарегистрируйтесь, играйте в квизы и получайте купоны любимых магазинов.",
  },
  "auth.pending_title": { az: "Kuponun səni gözləyir! 🎁", en: "Your coupon is waiting! 🎁", ru: "Ваш купон ждёт! 🎁" },
  "auth.pending_desc": {
    az: "Quiz nəticən yadda saxlanılıb — qeydiyyatı tamamla, kuponun dərhal hesabına düşsün.",
    en: "Your quiz result is saved — finish signing up and the coupon lands in your account.",
    ru: "Результат сохранён — завершите регистрацию, и купон появится в аккаунте.",
  },
  "auth.no_account": { az: "Hesabın yoxdur?", en: "No account yet?", ru: "Нет аккаунта?" },
  "auth.have_account": { az: "Hesabın var?", en: "Already have an account?", ru: "Уже есть аккаунт?" },
  "auth.register_link": { az: "Qeydiyyatdan keç", en: "Sign up", ru: "Зарегистрироваться" },
  "auth.login_link": { az: "Daxil ol", en: "Log in", ru: "Войти" },
  "auth.fullname": { az: "Ad Soyad", en: "Full name", ru: "Имя и фамилия" },
  "auth.fullname_placeholder": { az: "Ayşən Mirzəyeva", en: "John Smith", ru: "Иван Иванов" },
  "auth.phone": { az: "Telefon nömrəsi", en: "Phone number", ru: "Номер телефона" },
  "auth.password": { az: "Şifrə", en: "Password", ru: "Пароль" },
  "auth.submit_login": { az: "Daxil ol", en: "Log in", ru: "Войти" },
  "auth.submit_register": { az: "Qeydiyyatdan keç", en: "Sign up", ru: "Зарегистрироваться" },
  "auth.intro_play": { az: "Oyna", en: "Play", ru: "Играй" },
  "auth.intro_answer": { az: "Cavabla", en: "Answer", ru: "Отвечай" },
  "auth.intro_win": { az: "Qazan", en: "Win", ru: "Выигрывай" },

  /* ---------------- doğrulama ---------------- */
  "validation.name_required": { az: "Ad Soyad boş ola bilməz.", en: "Full name is required.", ru: "Укажите имя и фамилию." },
  "validation.password_required": { az: "Şifrə boş ola bilməz.", en: "Password is required.", ru: "Введите пароль." },
  "validation.password_min": { az: "Şifrə minimum 6 simvol olmalıdır.", en: "Password must be at least 6 characters.", ru: "Пароль должен быть не короче 6 символов." },
  "validation.phone_required": { az: "Telefon nömrəsi boş ola bilməz.", en: "Phone number is required.", ru: "Введите номер телефона." },
  "validation.phone_invalid": { az: "Telefon nömrəsi düzgün formatda deyil.", en: "Invalid phone number format.", ru: "Неверный формат номера телефона." },

  /* ---------------- xətalar ---------------- */
  "errors.network": {
    az: "Şəbəkə problemi. Xahiş edirik, internet bağlantınızı yoxlayın.",
    en: "Network problem. Please check your internet connection.",
    ru: "Проблема с сетью. Проверьте подключение к интернету.",
  },
  "errors.phone_taken": { az: "Bu telefon nömrəsi artıq qeydiyyatdadır.", en: "This phone number is already registered.", ru: "Этот номер уже зарегистрирован." },
  "errors.validation": { az: "Daxil etdiyiniz məlumatda səhv var.", en: "There is a problem with the data you entered.", ru: "В введённых данных есть ошибка." },
  "errors.unauthorized": { az: "Giriş icazəniz yoxdur. Yenidən daxil olun.", en: "You are not authorized. Please log in again.", ru: "Нет доступа. Войдите снова." },
  "errors.forbidden": { az: "İcazə yoxdur. Hesabınızla bağlı problem ola bilər.", en: "Access denied. There may be an issue with your account.", ru: "Доступ запрещён. Возможна проблема с аккаунтом." },
  "errors.not_found": { az: "Tələb olunan resurs tapılmadı.", en: "The requested resource was not found.", ru: "Запрошенный ресурс не найден." },
  "errors.server": { az: "Serverdə problem baş verdi. Zəhmət olmasa yenidən cəhd edin.", en: "A server error occurred. Please try again.", ru: "Ошибка сервера. Попробуйте ещё раз." },
  "errors.unavailable": { az: "Xidmət müvəqqəti olaraq əlçatmazdır. Bir az sonra yenidən yoxlayın.", en: "The service is temporarily unavailable. Please try later.", ru: "Сервис временно недоступен. Попробуйте позже." },
  "errors.generic": { az: "Gözlənilməz xəta baş verdi. Zəhmət olmasa yenidən cəhd edin.", en: "An unexpected error occurred. Please try again.", ru: "Произошла непредвиденная ошибка. Попробуйте ещё раз." },

  /* ---------------- abunəlik ---------------- */
  "sub.plans_title": { az: "Abunəlik paketləri", en: "Subscription plans", ru: "Тарифные планы" },
  "sub.plans_subtitle": {
    az: "Quizzo-dan tam yararlanmaq üçün aylıq paketlərdən birini seç — quiz oyna, endirim kuponları qazan. 🎯",
    en: "Pick a monthly plan to get the most out of Quizzo — play quizzes and win discount coupons. 🎯",
    ru: "Выберите месячный тариф, чтобы пользоваться Quizzo полностью — играйте и получайте купоны. 🎯",
  },
  "sub.no_plans": { az: "Hələ satışda paket yoxdur", en: "No plans on sale yet", ru: "Тарифов пока нет" },
  "sub.no_plans_desc": { az: "Bir az sonra yenidən yoxlayın.", en: "Please check back soon.", ru: "Загляните позже." },
  "sub.subscribe": { az: "Abunə ol", en: "Subscribe", ru: "Оформить" },
  "sub.login_and_subscribe": { az: "Daxil ol və abunə ol", en: "Log in & subscribe", ru: "Войти и оформить" },
  "sub.activate": { az: "Aktivləşdir", en: "Activate", ru: "Активировать" },
  "sub.current_plan_badge": { az: "Cari paketin", en: "Your current plan", ru: "Ваш тариф" },
  "sub.trial_badge": { az: "Sınaq", en: "Trial", ru: "Пробный" },
  "sub.is_active_label": { az: "Aktivdir", en: "Active", ru: "Активен" },
  "sub.wait": { az: "Gözləyin...", en: "Please wait...", ru: "Подождите..." },
  "sub.free": { az: "Pulsuz", en: "Free", ru: "Бесплатно" },
  "sub.free_trial": { az: "Pulsuz sınaq", en: "Free trial", ru: "Бесплатный период" },
  "sub.period_month": { az: "ay", en: "month", ru: "мес." },
  "sub.period_year": { az: "il", en: "year", ru: "год" },
  "sub.period_days": { az: "{count} gün", en: "{count} days", ru: "{count} дн." },
  "sub.feature_daily": { az: "Gündəlik quiz: {value}", en: "Quizzes per day: {value}", ru: "Квизов в день: {value}" },
  "sub.feature_monthly": { az: "Aylıq kupon: {value}", en: "Coupons per month: {value}", ru: "Купонов в месяц: {value}" },

  "sub.my_title": { az: "💳 Abunəliyim", en: "💳 My subscription", ru: "💳 Моя подписка" },
  "sub.current_plan": { az: "Cari paket", en: "Current plan", ru: "Текущий тариф" },
  "sub.no_plan": { az: "Paket seçilməyib", en: "No plan selected", ru: "Тариф не выбран" },
  "sub.status_active": { az: "Aktiv", en: "Active", ru: "Активна" },
  "sub.status_inactive": { az: "Passiv", en: "Inactive", ru: "Неактивна" },
  "sub.ends_at": { az: "Bitmə tarixi", en: "Expires on", ru: "Действует до" },
  "sub.usage_quizzes": { az: "Bu gün oynanılan quiz", en: "Quizzes played today", ru: "Квизов сыграно сегодня" },
  "sub.usage_coupons": { az: "Bu ay qazanılan kupon", en: "Coupons earned this month", ru: "Купонов получено за месяц" },
  "sub.saved_card": { az: "💳 Yadda saxlanılan kart: {mask}", en: "💳 Saved card: {mask}", ru: "💳 Сохранённая карта: {mask}" },
  "sub.auto_renew": { az: "🔄 Avtomatik yenilənmə: {state}", en: "🔄 Auto-renewal: {state}", ru: "🔄 Автопродление: {state}" },
  "sub.on": { az: "Açıq", en: "On", ru: "Вкл" },
  "sub.off": { az: "Bağlı", en: "Off", ru: "Выкл" },
  "sub.remove_card": { az: "Kartı sil", en: "Remove card", ru: "Удалить карту" },
  "sub.pending_title": { az: "⏳ Ödənilməmiş sorğunuz var", en: "⏳ You have an unpaid request", ru: "⏳ Есть неоплаченный запрос" },
  "sub.pending_desc": { az: "{plan} — {amount} {currency} ({periods} dövr)", en: "{plan} — {amount} {currency} ({periods} periods)", ru: "{plan} — {amount} {currency} ({periods} периодов)" },
  "sub.complete_payment": { az: "Ödənişi tamamla", en: "Complete payment", ru: "Завершить оплату" },
  "sub.cancel_request": { az: "Sorğunu ləğv et", en: "Cancel request", ru: "Отменить запрос" },
  "sub.change_plan": { az: "Paketi dəyiş / uzat", en: "Change / extend plan", ru: "Сменить / продлить тариф" },
  "sub.choose_plan": { az: "Paket seç", en: "Choose a plan", ru: "Выберите тариф" },
  "sub.save_card": { az: "Kartı yadda saxla", en: "Save my card", ru: "Сохранить карту" },
  "sub.history": { az: "📜 Tarixçə", en: "📜 History", ru: "📜 История" },
  "sub.th_plan": { az: "Paket", en: "Plan", ru: "Тариф" },
  "sub.th_amount": { az: "Məbləğ", en: "Amount", ru: "Сумма" },
  "sub.th_start": { az: "Başlanğıc", en: "Start", ru: "Начало" },
  "sub.th_end": { az: "Bitmə", en: "End", ru: "Окончание" },
  "sub.req_pending": { az: "Gözləyir", en: "Pending", ru: "Ожидает" },
  "sub.req_approved": { az: "Təsdiqlənib", en: "Approved", ru: "Подтверждён" },
  "sub.req_rejected": { az: "Rədd edilib", en: "Rejected", ru: "Отклонён" },
  "sub.req_cancelled": { az: "Ləğv edilib", en: "Cancelled", ru: "Отменён" },
  "sub.pay_success": { az: "Ödəniş uğurlu oldu — paketiniz aktivdir! 🎉", en: "Payment successful — your plan is active! 🎉", ru: "Оплата прошла — тариф активен! 🎉" },
  "sub.pay_failed": { az: "Bank ödənişi təsdiqləmədi. Yenidən cəhd edə bilərsiniz.", en: "The bank declined the payment. You can try again.", ru: "Банк отклонил платёж. Попробуйте ещё раз." },
  "sub.pay_error": { az: "Ödəniş yoxlanıla bilmədi. Bir az sonra yenidən baxın.", en: "The payment could not be verified. Please check back later.", ru: "Не удалось проверить платёж. Загляните позже." },
  "sub.plan_activated": { az: "Paket aktivləşdirildi.", en: "Plan activated.", ru: "Тариф активирован." },
  "sub.claim_ready": { az: "🎉 Gözləyən kuponunuz hazırdır: {code}", en: "🎉 Your pending coupon is ready: {code}", ru: "🎉 Ваш купон готов: {code}" },
  "sub.claim_needed": { az: "Kuponu almaq üçün abunəlik lazımdır.", en: "A subscription is required to claim the coupon.", ru: "Для получения купона нужна подписка." },
  "sub.coupon_ready": { az: "🎉 Kuponunuz hazırdır: {code}", en: "🎉 Your coupon is ready: {code}", ru: "🎉 Ваш купон готов: {code}" },
  "sub.session_linked": { az: "Nəticəniz hesabınıza bağlandı.", en: "Your result has been linked to your account.", ru: "Результат привязан к вашему аккаунту." },
  "sub.claim_failed": { az: "Sessiyanı hesaba bağlamaq mümkün olmadı.", en: "Could not link the session to your account.", ru: "Не удалось привязать сессию к аккаунту." },

  /* ---------------- ünvan / xəritə ---------------- */
  "store.address_title": { az: "📍 Ünvan", en: "📍 Address", ru: "📍 Адрес" },
  "store.map_title": { az: "xəritə", en: "map", ru: "карта" },
  "store.open_in_maps": { az: "Google Maps-də aç →", en: "Open in Google Maps →", ru: "Открыть в Google Maps →" },

  /* ---------------- reklamlar ---------------- */
  "ads.title": { az: "📣 Reklamlar və elanlar", en: "📣 Ads & announcements", ru: "📣 Реклама и объявления" },
  "ads.until": { az: "Bitir: {date}", en: "Ends: {date}", ru: "До: {date}" },

  /* ---------------- menyu / hesab ---------------- */
  "nav.menu": { az: "Menyu", en: "Menu", ru: "Меню" },
  "nav.account": { az: "Hesabım", en: "My account", ru: "Мой аккаунт" },
  "nav.welcome_back": { az: "Xoş gəldin 👋", en: "Welcome back 👋", ru: "С возвращением 👋" },
  "nav.coupons_short": { az: "Kuponlarım", en: "My coupons", ru: "Мои купоны" },
  "common.close": { az: "Bağla", en: "Close", ru: "Закрыть" },

  /* ---------------- haqqında ---------------- */
  "nav.about": { az: "Haqqında", en: "About", ru: "О нас" },
  "about.not_available": { az: "Bu səhifə hazırda əlçatan deyil", en: "This page is not available right now", ru: "Эта страница сейчас недоступна" },
  "about.features_title": { az: "✨ Niyə Quizzo?", en: "✨ Why Quizzo?", ru: "✨ Почему Quizzo?" },
  "about.steps_title": { az: "🧭 Necə işləyir?", en: "🧭 How it works", ru: "🧭 Как это работает" },
  "about.contact_title": { az: "📬 Əlaqə", en: "📬 Contact", ru: "📬 Контакты" },
  "about.email": { az: "E-poçt", en: "Email", ru: "Эл. почта" },
  "about.phone": { az: "Telefon", en: "Phone", ru: "Телефон" },
  "about.address": { az: "Ünvan", en: "Address", ru: "Адрес" },
  "about.cta": { az: "🚀 Mağazalara bax", en: "🚀 Browse stores", ru: "🚀 Смотреть магазины" },
};

export default dictionary;
